import { apiClient } from '../axios-instance'


export interface AuditLogQuery {
  per_page?: number;
  page?: number;
  action?: string;
  user_id?: string;
  start_date?: string;
  end_date?: string;
}

export const auditService = {
  /**
   * Get all audit logs (paginated)
   */
  getAll: async (params?: AuditLogQuery): Promise<any> => {
    const response = await apiClient.get('/admin/audit/logs', { params })
    return response.data
  },

  /**
   * Get a specific audit log by ID
   */
  getById: async (id: string): Promise<any> => {
    const response = await apiClient.get(`/admin/audit/logs/${id}`)
    return response.data
  }
}
